// TerminalLoader.js
import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { Button } from 'antd';

const TerminalLoader = ({reschedulingData, goBack}) => {
    const [dots, setDots] = useState('');

    useEffect(() => {
        const interval = setInterval(() => {
            setDots((prevDots) => (prevDots.length < 100 ? prevDots + '.' : prevDots));
            
        }, 200); // Change dot animation speed as needed
        
        return () => clearInterval(interval);
    }, []);

    // reschedulingData && console.log(reschedulingData)
    return (
        // <div className={`${styles["terminal-loader"]}`}>
        //     Scanning Bookings [{dots}
        //         <span className={`${styles["square-bracket"]}`}>]</span>
        //     {/* <span className={`${styles["cursor"]}`}></span> */}
        // </div>
        <div>
            <div className={styles["terminal-loader"]}>
                <div className={styles["terminal-content"]}>
                    Scanning Bookings [{dots}
                </div>
                <span className={styles["square-bracket"]}>]</span>

            </div>
            <div>
                {dots.length >= 70 ? <div>
                    <div>
                        {reschedulingData.schedulerFlag === false ? 
                        "All Bookings Scheduled"
                        :
                        `${reschedulingData.rescheduledCount} jobs rescheduled`
                    }
                    </div>
                    <Button onClick={goBack}>Go Back</Button>
                </div>
                    :
                    <></>}
            </div>
        </div>
    );
};

export default TerminalLoader;
